import { component as defineComponent } from 'flightjs';
import $ from 'jquery';
import VelocityScrollable from 'marketing/models/velocity-scrollable-model';

const scrollable = function () {
    this.attributes({
        inner: '[data-scrollable-inner]',
        startingBreakpoint: null
    });

    this.after('initialize', function () {
        this.removeExtraSpacing();
        this.centerAlign();

        this.model = new VelocityScrollable(
            window.requestAnimationFrame.bind(window),
            this.move.bind(this)
        );

        if (this.attr.startingBreakpoint !== 'small') {
            this.model.start();
        }

        this.on(document, 'uiBreakpointChanged', this.toggleModel);
        this.on(this.node, 'mousemove', this.detectVelocity);
        this.on(this.node, 'mouseout', this.stopVelocity);
    });

    this.move = function (offset) {
        this.select('inner')[0].scrollLeft += offset;
    };

    this.stopVelocity = function () {
        this.model.velocity = 0;
    };

    this.detectVelocity = function (e) {
        const left = e.clientX;
        const right = document.documentElement.clientWidth - e.clientX;

        this.model.registerMovement(left, right);
    };

    /**
     * Adjust the spacing of a horizontally scrollable element to remove extra spacing
     * caused by browsers.
     */
    this.removeExtraSpacing = function () {
        const defaultHeightDifference = -20;

        let inner = this.select('inner')[0];
        let heightDifference = inner.clientHeight - this.node.clientHeight;

        if (heightDifference === 0) {
            inner.style.marginTop = defaultHeightDifference + 'px';
            inner.style.bottom = defaultHeightDifference + 'px';
            inner.style.paddingBottom = (-1 * defaultHeightDifference) + 'px';
        } else {
            inner.style.marginTop = heightDifference + 'px';
            inner.style.bottom = heightDifference + 'px';
        }
    };

    this.centerAlign = function () {
        return new Promise((resolve) => {
            this.select('inner').each((idx, el) => {
                el.scrollLeft = ($(el).data('size') - window.innerWidth) / 2;
            });

            resolve(this.select('inner'));
        });
    };

    this.toggleModel = function (e, breakpoint) {
        if (breakpoint === 'small') {
            this.model.stop();
        } else {
            this.model.start();
        }
    };
};

export default defineComponent(scrollable);



// WEBPACK FOOTER //
// ./src/web/js/marketing/ui/scrollable.js